<template>
    <div class="flex">
        <div class="row topCardGrid">
          <sp-card :valor="cards.recebidas" stripe="" :descricao="$t('atendimento.ouvidoria.cards.abertas', {periodo: corteTemporalEscolhido})" :lgGrid="3" :footerText="ref"/>
          <sp-card :valor="cards.semProtocolo" stripe="" :descricao="$t('atendimento.ouvidoria.cards.semProtocolo', {periodo: corteTemporalEscolhido})" :lgGrid="3" :footerText="ref"/>
          <sp-card :valor="cards.finalizadas" stripe="" :descricao="$t('atendimento.ouvidoria.cards.finalizadas', {periodo: corteTemporalEscolhido})" :lgGrid="3" :footerText="ref"/>
          <sp-card :valor="cards.canceladas" stripe="" :descricao="$t('atendimento.ouvidoria.cards.canceladas', {periodo: corteTemporalEscolhido})" :lgGrid="3" :footerText="ref"/>
          <sp-card :valor="cards.indeferidas" stripe="" :descricao="$t('atendimento.ouvidoria.cards.indeferidas', {periodo: corteTemporalEscolhido})" :lgGrid="3" :footerText="ref"/>
        </div>
        <div class="row">
          <div class="flex md12 sm12">
            <sp-360-panel :title="$t('atendimento.ouvidoria.painel.titulo', {regiao : subSel? subSel.nome : 'São Paulo'})" id="painelSup" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef } )"
            :footerComplementar="$t('atendimento.ouvidoria.painel.rodape', {chamados: total, noGeoRef: noGeoRef})">

                  <div class="flex lg12 sm12 md12">
                      <va-tabs class="tabPadding" v-model="showTableOrgao">
                          <va-tab v-for="option in showTableOrgaoOptions" :key="option.atributo">
                            {{ option.label }}
                          </va-tab>
                      </va-tabs>
                  </div>

                  <div class="flex-box">
                      <div class="flex lg4 sm12 md4">
                        <multiselect id="selectSubprefeituras" name="Subprefeituras" placeholder="Selecione uma Subprefeitura" :disabled="!!showTableOrgao"
                          track-by="nome" label="nome" :value="subSel" :options="subs" :close-on-select="true" :show-labels="false"
                          @input="updateMultiSelect" />
                      </div>
                      <div class="flex lg8 sm12 md8">
                        <multiselect
                          id="selectSegmentoTemporal"
                          name="selectTemporal"
                          :placeholder="$t('mainDashboard.filterTablePlaceholder')"
                          :value="corteTemporalEscolhido"
                          :options="corteTemporal"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :allowEmpty="false"
                          @input="updatesub"/>
                      </div>
                  </div>

                  <div class="flex-box">
                      <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP"
                          :habilitarAnimacaoClique="!showTableOrgao"/>

                      <sp360-data-table id="tabelaServicos" ref="tabelaServicos" v-show="showTableOrgao === 0" :apiMode="false"
                          :data="tabela.data" :fields="tabela.tableFields"
                          :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" :footerObj="footerGeral"/>

                      <sp360-data-table id="tabelaServicosPorOrgao" ref="tabelaServicosPorOrgao"  v-show="showTableOrgao === 1" :apiMode="false"
                        :data="tabela.dataOrgao" :fields="tabela.tableFieldsOrgao"
                        :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" />

                      <sp360-data-table id="tabelaServicosPorSub" ref="tabelaServicosPorSub" v-show="showTableOrgao === 2" :apiMode="false"
                        :data="tabela.dataSub" :fields="tabela.tableFieldsSub"
                        :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" />
                  </div>

            </sp-360-panel>
          </div>
        </div>
        <div class="row">
          <div class="flex md12 sm12">
            <sp-360-panel :title="$t('atendimento.ouvidoria.painel.tituloSub', {regiao : subSel? subSel.nome : 'São Paulo'})" id="painelSup" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef } )">
              <va-tabs class="tabPadding" v-model="showTableTreeSub">
                <va-tab v-for="option in showTableTreeSubOptions" :key="option.atributo">
                {{ option.label }}
                </va-tab>
              </va-tabs>

                <div class="flex lg4 sm12 md4">
                  <multiselect
                    id="selectSegmentoTemporal"
                    name="selectTemporal"
                    :placeholder="$t('mainDashboard.filterTablePlaceholder')"
                    :value="corteTemporalEscolhido"
                    :options="corteTemporal"
                    :searchable="false"
                    :close-on-select="true"
                    :show-labels="false"
                    :allowEmpty="false"
                    @input="updatesub"/>
                </div>

              <grafico-tree  v-show="!showTableTreeSub" :dados="dadosTreeSub" ref="graficoArvoreSub" class="treeContainer"/>
              <sp360-data-table id="tabelaServicosPorSub2" ref="tabelaServicosPorSub" v-show="showTableTreeSub" :apiMode="false"
                :data="tabela.dataSub" :fields="tabela.tableFieldsSub"
                :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" :title="$t('atendimento.ouvidoria.painel.titulo', {regiao : subSel? subSel.nome : 'São Paulo'})"/>

            </sp-360-panel>
          </div>
        </div>
        <div class="row">
          <div class="flex md12 sm12">
            <sp-360-panel :title="$t('atendimento.ouvidoria.painel.tituloOrgao', {regiao : subSel? subSel.nome : 'São Paulo'})" id="painelSup" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef } )">

              <va-tabs class="tabPadding" v-model="showTableTreeOrgao">
                <va-tab v-for="option in showTableTreeOrgaoOptions" :key="option.atributo">
                  {{ option.label }}
                </va-tab>
              </va-tabs>

                <div class="flex lg4 sm12 md4">
                  <multiselect
                    id="selectSegmentoTemporal"
                    name="selectTemporal"
                    :placeholder="$t('mainDashboard.filterTablePlaceholder')"
                    :value="corteTemporalEscolhido"
                    :options="corteTemporal"
                    :searchable="false"
                    :close-on-select="true"
                    :show-labels="false"
                    :allowEmpty="false"
                    @input="updatesub"/>
                </div>

              <grafico-tree v-show="!showTableTreeOrgao" :dados="dadosTreeOrgao" ref="graficoArvoreOrgao" class="treeContainer"/>
              <sp360-data-table id="tabelaServicosPorOrgao2" ref="tabelaServicosPorOrgao"  v-show="showTableTreeOrgao" :apiMode="false"
                          :data="tabela.dataOrgao" :fields="tabela.tableFieldsOrgao"
                          :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" :title="$t('atendimento.ouvidoria.painel.titulo', {regiao : subSel? subSel.nome : 'São Paulo'})"/>

            </sp-360-panel>
          </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import AutoUpdate from '@/services/AutoUpdate'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Multiselect from 'vue-multiselect'
import VueMonthlyPicker from 'vue-monthly-picker'
import GraficoTree from '@/components/statistics/charts/GraficoTree'
import RankingTreeMap from '@/components/statistics/charts/RankingTreeMap'
import * as d3 from 'd3'

import SolicitacoesBarTable from '@/components/statistics/charts/SolicitacoesBarTable'
import RankingSubOrgao from '@/components/statistics/charts/RankingSubOrgao'

export default {
  name: 'servicos-ouvidoria',
  mixins: [AutoUpdate],
  components: {
    SpCard,
    SpMap,
    MethGlob,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Multiselect,
    VueMonthlyPicker,
    SPMapaNomes,
    'bar-table-regiao-orgao': SolicitacoesBarTable,
    'ranking-sub-orgao': RankingSubOrgao,
    RankingSubOrgao,
    GraficoTree,
    RankingTreeMap,
  },

  computed: {
  },

  data () {
    return {
      cards: {},
      ref: '',
      footerGeral: {},
      subSel: null,
      tabela: { data: [], dataOrgao: [], dataSub: [], tableFields: [], tableFieldsOrgao: [], tableFieldsSub: [], itemsPerPage: 10 },
      dataRef: new Date(),
      fonte: '',
      subs: [],
      dadosSub: [],
      municipio: {},
      showTableOrgaoOptions: [{ atributo: 0, label: 'Região' }, { atributo: 1, label: 'Orgão' }, { atributo: 2, label: 'Subprefeitura' }],
      showTableOrgao: 0,
      dadosTreeOrgao: [],
      dadosTreeSub: [],
      showTableTreeOrgaoOptions: [{ atributo: 0, label: 'Grafico' }, { atributo: 1, label: 'Tabela' }],
      showTableTreeOrgao: 0,
      showTableTreeSubOptions: [{ atributo: 0, label: 'Grafico' }, { atributo: 1, label: 'Tabela' }],
      showTableTreeSub: 0,
      total: 0,
      noGeoRef: 0,
      cards: {},
      corteTemporalEscolhido: this.$t('mainDashboard.multiselect.ultimos30Dias'),
      corteTemporal: [
        this.$t('mainDashboard.multiselect.ultimoMesFechado'),
        this.$t('mainDashboard.multiselect.ultimoSemestreFechado'),
        this.$t('mainDashboard.multiselect.ultimos30Dias'),
        this.$t('mainDashboard.multiselect.ultimos180Dias'),
      ],
    }
  },

  mounted () {
    Promise.all([
      // Não Mudar a Ordem das chamadas
      // 0-3
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorRegiao', { top: 100, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/servicosNaoGeorreferenciadosOuvidoria', { top: 100, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorOrgao', { top: 100, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaConsolidados', { top: 100, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' }),

      // 4-7
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorRegiao', { top: 100, intervalo: 'ULTIMO_MES_FECHADO', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/servicosNaoGeorreferenciadosOuvidoria', { top: 100, intervalo: 'ULTIMO_MES_FECHADO', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorOrgao', { top: 100, intervalo: 'ULTIMO_MES_FECHADO', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaConsolidados', { top: 100, intervalo: 'ULTIMO_MES_FECHADO', ordenacao: 'recebidas' }),

      // 8-11
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorRegiao', { top: 100, intervalo: 'ULTIMO_SEMESTRE', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/servicosNaoGeorreferenciadosOuvidoria', { top: 100, intervalo: 'ULTIMO_SEMESTRE', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorOrgao', { top: 100, intervalo: 'ULTIMO_SEMESTRE', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaConsolidados', { top: 100, intervalo: 'ULTIMO_SEMESTRE', ordenacao: 'recebidas' }),

      // 12-15
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorRegiao', { top: 100, intervalo: 'ULTIMO_SEMESTRE_FECHADO', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/servicosNaoGeorreferenciadosOuvidoria', { top: 100, intervalo: 'ULTIMO_SEMESTRE_FECHADO', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorOrgao', { top: 100, intervalo: 'ULTIMO_SEMESTRE_FECHADO', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaConsolidados', { top: 100, intervalo: 'ULTIMO_SEMESTRE_FECHADO', ordenacao: 'recebidas' }),

      // cards
      this.$store.dispatch('ouvidoria/solicitacoesOuvidoriaConsolidado'),
      
    ]).then((respostas) => {
      this.reclamacoesSemProtocolo = []
      this.consolidados = respostas.pop().data.data

      this.dadosUltimos30Dias = respostas.slice(0, 4)
      this.dadosUltimoMesFechado = respostas.slice(4, 8)
      this.dadosUltimos180Dias = respostas.slice(8, 12)
      this.dadosUltimoSemestreFechado = respostas.slice(12)

      Promise.all([// Informacoes dos totais por região
        
        this.$store.dispatch('servicos156/buscarTopPorRegiao', {topReqs: 200, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas', filtroId:  this.criarFiltroIdServico(this.dadosUltimos30Dias[0])}),
        this.$store.dispatch('servicos156/buscarTopPorRegiao', {topReqs: 200, intervalo: 'ULTIMO_MES_FECHADO', ordenacao: 'recebidas', filtroId:  this.criarFiltroIdServico(this.dadosUltimoMesFechado[0]) }),
        this.$store.dispatch('servicos156/buscarTopPorRegiao', {topReqs: 200, intervalo: 'ULTIMO_SEMESTRE', ordenacao: 'recebidas', filtroId:  this.criarFiltroIdServico(this.dadosUltimos180Dias[0]) }),
        this.$store.dispatch('servicos156/buscarTopPorRegiao', {topReqs: 200, intervalo: 'ULTIMO_SEMESTRE_FECHADO', ordenacao: 'recebidas', filtroId:  this.criarFiltroIdServico(this.dadosUltimoSemestreFechado[0]) }),

        this.$store.dispatch('servicos156/buscarTopPorOrgao', {topReqs: 200, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas', filtroId:  this.criarFiltroIdServico(this.dadosUltimos30Dias[2]) }),
        this.$store.dispatch('servicos156/buscarTopPorOrgao', {topReqs: 200, intervalo: 'ULTIMO_MES_FECHADO', ordenacao: 'recebidas', filtroId:  this.criarFiltroIdServico(this.dadosUltimoMesFechado[2]) }),
        this.$store.dispatch('servicos156/buscarTopPorOrgao', {topReqs: 200, intervalo: 'ULTIMO_SEMESTRE', ordenacao: 'recebidas', filtroId:  this.criarFiltroIdServico(this.dadosUltimos180Dias[2]) }),
        this.$store.dispatch('servicos156/buscarTopPorOrgao', {topReqs: 200, intervalo: 'ULTIMO_SEMESTRE_FECHADO', ordenacao: 'recebidas', filtroId:  this.criarFiltroIdServico(this.dadosUltimoSemestreFechado[2]) })])
      .then((totalSolicitacao) => {      

        this.complementarComTotalDeSolicitacoesPorRegiao(this.dadosUltimos30Dias[0].data.data, totalSolicitacao[0].data.data)
        this.complementarComTotalDeSolicitacoesPorOrgao(this.dadosUltimos30Dias[2].data.data, totalSolicitacao[4].data.data)
        this.removerReclamacoesSemProtocolo(this.dadosUltimos30Dias[0].data.data)
        this.removerReclamacoesSemProtocolo(this.dadosUltimos30Dias[2].data.data)

        this.complementarComTotalDeSolicitacoesPorRegiao(this.dadosUltimoMesFechado[0].data.data, totalSolicitacao[1].data.data)
        this.complementarComTotalDeSolicitacoesPorOrgao(this.dadosUltimoMesFechado[2].data.data, totalSolicitacao[5].data.data)
        this.removerReclamacoesSemProtocolo(this.dadosUltimoMesFechado[0].data.data)
        this.removerReclamacoesSemProtocolo(this.dadosUltimoMesFechado[2].data.data)
        
        this.complementarComTotalDeSolicitacoesPorRegiao(this.dadosUltimos180Dias[0].data.data, totalSolicitacao[2].data.data)
        this.complementarComTotalDeSolicitacoesPorOrgao(this.dadosUltimos180Dias[2].data.data, totalSolicitacao[6].data.data)
        this.removerReclamacoesSemProtocolo(this.dadosUltimos180Dias[0].data.data)
        this.removerReclamacoesSemProtocolo(this.dadosUltimos180Dias[2].data.data)
        
        this.complementarComTotalDeSolicitacoesPorRegiao(this.dadosUltimoSemestreFechado[0].data.data, totalSolicitacao[3].data.data)
        this.complementarComTotalDeSolicitacoesPorOrgao(this.dadosUltimoSemestreFechado[2].data.data, totalSolicitacao[7].data.data)
        this.removerReclamacoesSemProtocolo(this.dadosUltimoSemestreFechado[0].data.data)
        this.removerReclamacoesSemProtocolo(this.dadosUltimoSemestreFechado[2].data.data)

        // Define Tabela
        this.tabela.tableFields = this.definirTabela()
        this.tabela.tableFieldsSub = this.definirTabela('sub')
        this.tabela.tableFieldsOrgao = this.definirTabela('orgao')

        // Define as Lista de Subprefeituras
        this.subs = _.orderBy(SPMapaNomes.slice(1), 'nome')

        // Definição inicial da tela ::: Dados dos ultimos 30 dias
        // this.defineRodape(this.dadosUltimos30Dias, 'recebidas')
        // this.defineDados(this.dadosUltimos30Dias)
        // this.defineCards()

        this.updateDadosUltimos30Dias()
      })
    })
  },
  methods: {
    removerReclamacoesSemProtocolo (subs) {
      subs.forEach(sub => {
        sub.reclamacoesSemProtocolo = _.remove(sub.servicos, (el) => { return el.servico_desc === 'Reclamação sem protocolo de 1ª Instância' })
      })
    },

    criarFiltroIdServico(dataset) {
      let topServicosId = []
      dataset.data.data.forEach(x => {
        x.servicos.forEach(servico => {
          if (!topServicosId.includes(servico.servico_id)) {
            topServicosId.push(servico.servico_id);
          }
        })
      })
      return topServicosId.join(",")
    },

    complementarComTotalDeSolicitacoesPorRegiao(datasetOuvidoria, datasetSolicitacoesTotal) {
      for(let i=0; i < datasetOuvidoria.length; i++) {
        datasetOuvidoria[i].servicos.forEach(servico => {
          servico.recebidas_total = servico.recebidas
          datasetSolicitacoesTotal[i].servicos.some(servicoTotal => {
            if(servico.servico_id === servicoTotal.servico_id) {
              servico.recebidas_total = servicoTotal.recebidas
              return true;
            }
          })
        })
      }

    },

    complementarComTotalDeSolicitacoesPorOrgao(datasetOuvidoria, datasetSolicitacoesTotal) {
      datasetOuvidoria.forEach(orgao => {
        orgao.servicos.forEach(servico => {
          servico.recebidas_total = servico.recebidas
          datasetSolicitacoesTotal.some(x => {
            if(x.orgao === orgao.orgao) {
              x.servicos.some(servicoTotal => {
                if(servico.servico_id === servicoTotal.servico_id) {
                  servico.recebidas_total = servicoTotal.recebidas
                  return true;
                }
              })
            }
          })
        })
      })
    },

    defineDados (respostas) {
      this.dadosSub = _.orderBy(respostas[0].data.data, 'recebidas', 'desc')
      this.dataOrgao = _.orderBy(respostas[2].data.data, 'recebidas', 'desc')

      this.dadosSub.forEach(el => {
        let total = {
          abertas: 0,
          canceladas: 0,
          deferidas: 0,
          finalizadas: 0,
          indeferidas: 0,
          recebidas: 0,
          recebidas_total: 0,
          proporcao_reclamacoes: 0,
          total: 0,
        }
        el.servicos.forEach(serv => {
          total.abertas += serv.abertas
          total.canceladas += serv.canceladas
          total.deferidas += serv.deferidas
          total.finalizadas += serv.finalizadas
          total.indeferidas += serv.indeferidas
          total.recebidas += serv.recebidas
          total.recebidas_total += serv.recebidas_total
          total.total += serv.total
          serv.proporcao_reclamacoes = (serv.recebidas*100/serv.recebidas_total) || 0
        })
        total.proporcao_reclamacoes = (total.recebidas*100/total.recebidas_total) || 0
        el.somatorios = total
        el.recebidas_total = total.recebidas_total
        el.proporcao_reclamacoes = (el.recebidas*100/el.recebidas_total) || 0
      })

      this.dataOrgao.forEach(el => {
        let total = {
          abertas: 0,
          canceladas: 0,
          deferidas: 0,
          finalizadas: 0,
          indeferidas: 0,
          recebidas: 0,
          recebidas_total: 0,
          proporcao_reclamacoes: 0,
          total: 0,
        }
        el.servicos.forEach(serv => {
          total.abertas += serv.abertas
          total.canceladas += serv.canceladas
          total.deferidas += serv.deferidas
          total.finalizadas += serv.finalizadas
          total.indeferidas += serv.indeferidas
          total.recebidas += serv.recebidas
          total.recebidas_total += serv.recebidas_total
          total.total += serv.total
          serv.proporcao_reclamacoes = (serv.recebidas*100/serv.recebidas_total) || 0
        })
        total.proporcao_reclamacoes = (total.recebidas*100/total.recebidas_total) || 0
        el.somatorios = total
        el.recebidas_total = total.recebidas_total
        el.proporcao_reclamacoes = (el.recebidas*100/el.recebidas_total) || 0
      })

      this.cloneDados = _.cloneDeep(this.dadosSub)
      this.municipio = _.remove(this.cloneDados, (e) => e.nome === 'GERAL')

      this.cards = this.municipio[0].somatorios

      this.pintarMapa(this.cloneDados, 'media_atendimento_dias', this.$t('atendimento.ouvidoria.painel.legenda'))
      this.popularTabela(0)

      _.remove(this.dataOrgao, (e) => e.orgao === 'GERAL')
      this.tabela.dataOrgao = this.definirPosicao(this.dataOrgao)
      this.dadosTreeOrgao = this.populateTreePorSub(this.dataOrgao, 'graficoArvoreOrgao', 'recebidas', 'total')

      this.tabela.dataSub = this.definirPosicao(this.cloneDados)
      this.dadosTreeSub = this.populateTreePorSub(this.cloneDados, 'graficoArvoreSub', 'recebidas', 'total')
    },

    defineCards (index) {
      this.cards = this.consolidados[index]
    },

    defineRodape (respostas, prop) {
      this.total = respostas[1].data.data[1][prop] + respostas[1].data.data[0][prop]
      this.noGeoRef = respostas[1].data.data[0][prop]

      this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
      this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
    },

    definirPosicao (dados) {
      let posicao = 0
      _.forEach(dados, (e) => {
        posicao++
        e.posicao = posicao
      })
      return dados
    },

    pintarMapa (data, prop, legenda) {
      let mapaCores = {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      }
      let dados = _.orderBy(data, [prop], 'asc')

      let first = _.first(dados)[prop]
      let last = _.last(dados)[prop]

      let colorScale = d3.scaleLinear()
        .domain([0, 1])
        .range([mapaCores.claro, mapaCores.escuro])

      dados.forEach(o => {
        if (o.id) {
          var norm = (o[prop] - first) / (last - first)
          this.$refs.mapa.pintarRegiao('sub' + o.id, colorScale(norm))
        }
      })

      this.$refs.mapa.setLegenda(first, last, legenda, 5)
      this.$refs.mapa.definirLegenda([mapaCores.claro, mapaCores.medio, mapaCores.escuro], [this.$t('mainDashboard.legendaTitulo'), this.$t('mainDashboard.legendaBaixa'), this.$t('mainDashboard.legendaMedia'), this.$t('mainDashboard.legendaAlta')])
    },

    definirTabela (selection) {
      let servico = {
        name: 'servico_desc',
        sortField: 'servico_desc',
        title: this.$t('atendimento.ouvidoria.painel.tabela.servico_desc'),
        width: '60%',
      }
      let orgao = {
        name: 'orgao',
        sortField: 'orgao',
        title: this.$t('graficos156.tableFields.orgao'),
        width: '40%',
      }
      let sub = {
        name: 'nome',
        sortField: 'nome',
        title: this.$t('graficos156.tableFields.sub'),
        width: '40%',
      }
      let fields = [
        {
          name: 'recebidas',
          sortField: 'recebidas',
          title: this.$t('atendimento.ouvidoria.painel.tabela.recebidas'),
          width: '20%',
          callback: function (x) {
            if (!isNaN(x)) {
              return MethGlob.formatarNumero(x)
            }
            return x
          },
        },
        {
          name: 'recebidas_total',
          sortField: 'recebidas_total',
          title: this.$t('atendimento.ouvidoria.painel.tabela.total_recebidas'),
          width: '20%',
          callback: function (x) {
            if (!isNaN(x)) {
              return MethGlob.formatarNumero(x)
            }
            return x
          },
        },
        {
          name: 'proporcao_reclamacoes',
          sortField: 'proporcao_reclamacoes',
          title: this.$t('atendimento.ouvidoria.painel.tabela.proporcao_reclamacoes'),
          width: '20%',
          callback: function (x) {
            if (!isNaN(x)) {
              return MethGlob.formataPercentual(x)
            }
            return x
          },
        },
        {
          name: 'finalizadas',
          sortField: 'finalizadas',
          title: this.$t('atendimento.ouvidoria.painel.tabela.finalizadas'),
          width: '20%',
          callback: function (x) {
            if (!isNaN(x)) {
              return MethGlob.formatarNumero(x)
            }
            return x
          },
        },
        {
          name: 'media_atendimento_dias',
          sortField: 'media_atendimento_dias',
          title: this.$t('atendimento.ouvidoria.painel.tabela.media_atendimento_dias'),
          width: '20%',
          callback: this.formatarNumeroDias,
        },
        // {
        //   name: 'abertas',
        //   sortField: 'abertas',
        //   title: this.$t('atendimento.ouvidoria.painel.tabela.abertas'),
        //   width: '6,875%',
        //   callback: function (x) {
        //     if (!isNaN(x)) {
        //       return MethGlob.formatarNumero(x)
        //     }
        //     return x
        //   },
        // },
        // {
        //   name: 'canceladas',
        //   sortField: 'canceladas',
        //   title: this.$t('atendimento.ouvidoria.painel.tabela.canceladas'),
        //   width: '6,875%',
        //   callback: function (x) {
        //     if (!isNaN(x)) {
        //       return MethGlob.formatarNumero(x)
        //     }
        //     return x
        //   },
        // },
        // {
        //   name: 'deferidas',
        //   sortField: 'deferidas',
        //   title: this.$t('atendimento.ouvidoria.painel.tabela.deferidas'),
        //   width: '6,875%',
        //   callback: function (x) {
        //     if (!isNaN(x)) {
        //       return MethGlob.formatarNumero(x)
        //     }
        //     return x
        //   },
        // },
        // {
        //   name: 'indeferidas',
        //   sortField: 'indeferidas',
        //   title: this.$t('atendimento.ouvidoria.painel.tabela.indeferidas'),
        //   width: '6,875%',
        //   callback: function (x) {
        //     if (!isNaN(x)) {
        //       return MethGlob.formatarNumero(x)
        //     }
        //     return x
        //   },
        // },
        // {
        //   name: 'total',
        //   sortField: 'total',
        //   title: this.$t('atendimento.ouvidoria.painel.tabela.total'),
        //   width: '6,875%',
        //   callback: function (x) {
        //     if (!isNaN(x)) {
        //       return MethGlob.formatarNumero(x)
        //     }
        //     return x
        //   },
        // },
      ]

      switch (selection) {
        case 'sub' : fields.unshift(sub)
          break
        case 'orgao' : fields.unshift(orgao)
          break
        default: fields.unshift(servico)
      }

      let position = {
        name: 'posicao',
        title: '#',
        titleClass: 'center aligned',
        dataClass: 'right aligned',
      }
      fields.unshift(position)
      return fields
    },

    updateMultiSelect (value) {
      if (!value) { // false
        value = this.subSel // use o ultimo selecionado
      }
      this.filtrarPorRegiao('sub' + value.id)
    },

    // TODO : Refatorar
    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub !== id) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.diminuirOpacidadeTodas()
        this.$refs.mapa.aumentarOpacidade(id)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
        this.subSel = _.find(this.subs, (e) => e.id === idNum)
        this.$refs.mapa.emulateClick(id)
        // this.$refs.mapa.pintarRegiao(id, CorUtils.getCorPorNomeSp360(CorUtils.VERDE_MEDIO))
        this.popularTabela(idNum)
      } else {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.aumentarOpacidadeTodas()
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.subSel = null
        this.popularTabela(0)
      }
    },

    popularTabela (id, prop = 'servicos') {
      let s = _.find(this.dadosSub, (e) => e.id === id)
      s[prop] = this.definirPosicao(s[prop])
      this.tabela.data = (s) ? s[prop] : []
      this.footerGeral = { servico_desc: 'Totais', recebidas: s.somatorios.recebidas.toLocaleString('pt-BR'), recebidas_total: s.somatorios.recebidas_total.toLocaleString('pt-BR'), finalizadas: s.somatorios.finalizadas.toLocaleString('pt-BR') }
    },

    popularGraficoDadosHistoricos (dados) {
      let chartData = { datasets: [], labels: [] }
      let datasetVagas = {
        backgroundColor: CorUtils.getCorPorNomeSp360('vermelho-claro'),
        borderColor: this.$store.getters.palette.transparent,
        fill: false,
        data: [],
        yAxisID: 'y-axis-2',
        label: this.$t('atendimento.ouvidoria.painel.tabela.grafico.datasetLabelVagas'),
      }
      let datasetOcupacao = {
        backgroundColor: CorUtils.getCorPorNomeSp360('azul-columbia-claro'),
        borderColor: this.$store.getters.palette.transparent,
        fill: false,
        data: [],
        label: this.$t('atendimento.ouvidoria.painel.tabela.grafico.datasetLabel'),
      }
      let data = dados.slice(0)
      for (let index = 0; index < dados.length; index++) {
        const element = dados[index]
        let x = new Date(element.mes + '/01/' + element.ano)
        let y = element.perc_medio_ocupacao
        let z = element.total_vagas_contratadas

        datasetOcupacao.data.push({ t: x, y: y })
        datasetVagas.data.push({ t: x, y: z })
      }
      chartData.datasets.push(datasetOcupacao)
      chartData.datasets.push(datasetVagas)
      this.chartHistorico.data = chartData
    },

    getLineChartOptions (legendaX, legendaY, tipo, tooltipCustomizado = false, percentual = true, milhar = false) {
      return {
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            title: (tooltipItem, chart) => {
              const o = { year: 'numeric', month: 'short' }
              const date = new Date(tooltipItem[0].xLabel)
              return date.toLocaleDateString('pt-BR', o)
            },
            label: (tooltipItem, chart) => {
              let label = chart.datasets[0].label + '  ' || ''
              label += tooltipItem.yLabel + '%'
              return label
            },
          },
        },
        maintainAspectRatio: false,
        aspectRatio: 4,
        responsive: true,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          xAxes: [{
            display: true,
            type: 'time',
            // distribution: 'series',
            time: {
              displayFormats: {
                quarter: 'MMM YYYY',
              },
            },
            ticks: {
              min: new Date('12/01/2013'),
            },
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [{
            ticks: {
              min: 0, // minimum tick
              callback: (value) => MethGlob.formataPercentual(value),
            },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY || 'LegendaY'),
            },
          }, {
            id: 'y-axis-2',
            ticks: {
              min: 0, // minimum tick
              callback: (value) => value.toLocaleString('pt-BR'),
            },
            type: 'linear',
            position: 'right',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('atendimento.ouvidoria.painel.tabela.grafico.legendaX2'),
            },
            lineStyling: {
              spanGaps: false,
            },
          }],
        },
        plugins: {
          datalabels: {
            clamp: true,
            font: {
              size: 16,
              weight: 'bold',
            },
            anchor: 'start',
            align: 'end',
            color: '#000',
            display: false,
          },
        },
      }
    },

    formatarNumeroDias (x) {
      let unidade = x > 1 ? this.$t('mainDashboard.days') : this.$t('mainDashboard.day')

      let numeroFormatado = MethGlob.thousandSeparator(_.round(x), '.', null)
      return (numeroFormatado + unidade)
    },

    populateTreePorSub (dados, ref, atributo, totalizador, holder) {
      let obj = []
      let dadosClone = _.orderBy(_.clone(dados), totalizador, 'desc')

      _.forEach(dadosClone, (sub) => {
        let subClone = {}
        subClone.nome = sub.nome || sub.orgao
        subClone.totalizador = sub.somatorios[atributo]
        let services = {}
        if (sub.servicos) {
          _.forEach(sub.servicos, (serv) => {
            services[serv.servico_desc] = serv[atributo]
          })
          subClone.dados = services
        }
        obj.push(subClone)
      })
      this.$refs[ref].carregamentoInicial(obj)
      this.$refs[ref].chart.language.locale['_thousandSeparator'] = '.'
    },

    updateDadosUltimos180Dias () {
      // this.defineCards(0)
      this.defineDados(this.dadosUltimos180Dias)
      this.defineRodape(this.dadosUltimos180Dias, 'recebidas')
      if (this.dadosUltimos180Dias[0].data.data[0].reclamacoesSemProtocolo[0]) { this.cards.semProtocolo = this.dadosUltimos180Dias[0].data.data[0].reclamacoesSemProtocolo[0].recebidas || 0 }
    },

    updateDadosUltimos30Dias () {
      // this.defineCards(3)
      this.defineDados(this.dadosUltimos30Dias)
      this.defineRodape(this.dadosUltimos30Dias, 'recebidas')
      if (this.dadosUltimos30Dias[0].data.data[0].reclamacoesSemProtocolo[0]) { this.cards.semProtocolo = this.dadosUltimos30Dias[0].data.data[0].reclamacoesSemProtocolo[0].recebidas || 0 }
    },

    updateDadosUltimoMesFechado () {
      this.defineDados(this.dadosUltimoMesFechado)
      this.defineRodape(this.dadosUltimoMesFechado, 'recebidas')
      if (this.dadosUltimoMesFechado[0].data.data[0].reclamacoesSemProtocolo[0]) { this.cards.semProtocolo = this.dadosUltimoMesFechado[0].data.data[0].reclamacoesSemProtocolo[0].recebidas || 0 }
    },

    updateDadosUltimoSemestreFechado () {
      this.defineDados(this.dadosUltimoSemestreFechado)
      this.defineRodape(this.dadosUltimoSemestreFechado, 'recebidas')
      if (this.dadosUltimoSemestreFechado[0].data.data[0].reclamacoesSemProtocolo[0]) { this.cards.semProtocolo = this.dadosUltimoSemestreFechado[0].data.data[0].reclamacoesSemProtocolo[0].recebidas || 0 }
    },

    updatesub (value) {
      this.corteTemporalEscolhido = value
      if (this.corteTemporalEscolhido === this.corteTemporal[0]) { // ultimoMesFechado
        this.updateDadosUltimoMesFechado()
      } else if (this.corteTemporalEscolhido === this.corteTemporal[1]) { // ultimoSemestreFechado
        this.updateDadosUltimoSemestreFechado()
      } else if (this.corteTemporalEscolhido === this.corteTemporal[2]) { // ultimos30Dias
        this.updateDadosUltimos30Dias()
      } else if (this.corteTemporalEscolhido === this.corteTemporal[3]) { // ultimos180Dias
        this.updateDadosUltimos180Dias()
      }
    },

  },
}

</script>

<style lang="scss" scoped>

    .flex-box {
        display: flex;
    }

    #mapaSP{
       width: 35%;
    }

    #tabelaServicos {
        width: 65%;
    }
    #tabelaServicosPorOrgao{
        width: 65%;
    }
    #tabelaServicosPorSub{
        width: 65%;
    }

    .fa-arrow-up{
      color: green
    }

    .fa-arrow-down{
      color: red
    }
    .tabPadding {
      padding-bottom: 20px;
    }
    .treeContainer {
      height: 50rem;
    }
</style>
